import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ComponentMessage, MessageTopicsEnum } from '../models/component-message.model';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ComponentMessagingService {
  private subject = new Subject<ComponentMessage>();
  constructor() {}

  sendMessage(topic: MessageTopicsEnum, message: string | any) {
    this.subject.next({ topic: topic, content: message });
  }

  clearMessages() {
    this.subject.next();
  }

  onMessage(topic: MessageTopicsEnum = null): Observable<ComponentMessage> {
    if (topic) {
      return this.subject.asObservable().pipe(filter((msg) => msg.topic == topic));
    }
    return this.subject.asObservable();
  }
}
